import React from 'react';
import styles from "../../../styles/applicant/ApplicantTable.module.css";
import { FaSearch, FaFilter, FaColumns, FaLanguage, FaChevronDown, FaChevronUp } from "react-icons/fa";

const TableHeader = ({
    searchQuery,
    setSearchQuery,
    currentConfig,
    totalApprovedApplications,
    totalApplications,
    activeFilters,
    activeDropdown,
    toggleFilterMenu,
    toggleLanguageMenu,
    toggleColumnsMenu
}) => {
    return (
        <div className={styles.tableHeader}>
            <div className={styles.searchContainer}>
                <FaSearch className={styles.searchIcon} />
                <input
                    type="text"
                    placeholder={currentConfig.uiText.searchPlaceholder}
                    className={styles.search}
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                />
            </div>

            <div className={styles.statusSummary}>
                {currentConfig.uiText.statusSummary
                    .replace('{approvedCount}', totalApprovedApplications)
                    .replace('{totalCount}', totalApplications)}
            </div>

            <div className={styles.actionsContainer}>
                <div className={styles.dropdown}>
                    <button
                        className={`${styles.actionButton} ${activeDropdown === 'language' ? styles.active : ''}`}
                        onClick={toggleLanguageMenu}
                    >
                        <FaLanguage /> {currentConfig.uiText.language}
                        {activeDropdown === 'language' ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
                    </button>
                </div>

                <div className={styles.dropdown}>
                    <button
                        className={`${styles.actionButton} ${activeDropdown === 'filter' ? styles.active : ''}`}
                        onClick={toggleFilterMenu}
                    >
                        <FaFilter /> {currentConfig.uiText.filter} {activeFilters.length > 0 && `(${activeFilters.length})`}
                        {activeDropdown === 'filter' ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
                    </button>
                </div>

                <div className={styles.dropdown}>
                    <button
                        className={`${styles.actionButton} ${activeDropdown === 'columns' ? styles.active : ''}`}
                        onClick={toggleColumnsMenu}
                    >
                        <FaColumns /> {currentConfig.uiText.columns}
                        {activeDropdown === 'columns' ? <FaChevronUp size={12} /> : <FaChevronDown size={12} />}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TableHeader;